import "./styles/links.css";

import ymaps from 'ymaps';


const zoom = window.innerWidth < 400 ? 13 :
    window.innerWidth < 992 ? 14 : 15;

console.log({ zoom });

document.addEventListener("DOMContentLoaded", () => {
    ymaps
        .load('//api-maps.yandex.ru/2.1/?lang=ru_RU')
        .then(maps => {
            const map = new maps.Map('map', {
                center: [54.89979909697881, 52.30277170609769],
                zoom,
                controls: ['zoomControl'],
                behaviors: ['drag', 'multiTouch']
            });

            const not1 = new maps.Placemark([54.898577069798506, 52.28899249999998], {
                iconCaption: "Галеева Раиса Мифтаховна",
            }, {
                preset: 'islands#redIcon'
            });

            const not2 = new maps.Placemark([54.90517156978594, 52.304587], {
                iconCaption: "Гришенева Наталья Вениаминовна",
            }, {
                preset: 'islands#blueIcon'
            });

            const not3 = new maps.Placemark([54.90445756978408, 52.30901549999994], {
                iconCaption: "Исламова Эльвира Абузаровна",
            }, {
                preset: 'islands#greenIcon'
            });

            const not4 = new maps.Placemark([54.9057515697874, 52.31316599999995], {
                iconCaption: "Рафикова Разина Рауфовна",
            }, {
                preset: 'islands#blackIcon'
            });

            const not5 = new maps.Placemark([54.904245569783534, 52.31911299999988], {
                iconCaption: "Сауленко Алексей Леонидович",
            }, {
                preset: 'islands#whiteIcon'
            });

            const not6 = new maps.Placemark([54.899421069800624,52.295531999999945], {
                iconCaption: "Горшунова Фарида Рафатовна",
            }, {
                preset: 'islands#redIcon'
            });

            const not7 = new maps.Placemark([54.86580425798916,52.434307457672105], {
                iconCaption: "Кабирова Регина Хусаиновна",
            }, {
                preset: 'islands#blueIcon'
            });

            [not1, not2, not3, not4, not5, not6, not7].map(not => {
                map.geoObjects.add(not);
            });
        })
        .catch(error => console.log('Failed to load Yandex Maps', error));
});